<template>
  <div class="bootcamp-list-results">
    <BootcampResults
      :items="notPast"
      @child-element-render="handleRememberPosition"
    />
    <div class="bootcamp-list-results__past" v-if="past && past.length"></div>
    <h3 class="bootcamp-list-results__title">
      Passed Bootcamps
    </h3>
    <div class="bootcamp-list-results__past">
      <div
        v-for="item in past"
        :key="item.objectID"
        class="bootcamp-list-results__list-item"
      >
        <ListResult
          type="Bootcamps"
          :course="item"
          :gradient="$getGradient()"
          :tileImg="$getBootcampBackgroundImg(item)"
          :link="$buildContentLink('bootcamp', item)"
          :difficulty="item.difficulty || ''"
          :isFreeTrialUser="isFreeTrialUser"
          :learningAreaColor="getLearningAreaColor(item)"
          :learningArea="getLearningArea(item)"
          :showAddedDate="true"
          :instructorAtTheEnd="true"
          :showHeader="true"
          :displayVendor="true"
          @el-rend="handleRememberPosition"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { compareAsc } from 'date-fns'
import { getLearningAreaColor, getLearningArea } from '@/helpers'
import BootcampResults from '@/components/search/BootcampResults.vue'
import ListResult from '@/components/search/ListResult.vue'

const marked = require('marked')

export default {
  name: 'BootcampListResults',
  components: {
    BootcampResults,
    ListResult,
  },
  data: () => {
    return {
      getLearningAreaColor,
      getLearningArea,
    }
  },
  props: {
    // should be all the bootcamps, no pagination in favor of grouping
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isFreeTrialUser: 'auth/isFreeTrialUser',
    }),
    notPast() {
      return this.items.filter(b => {
        return compareAsc(new Date(b.end_datetime * 1000), new Date()) >= 0
      })
    },
    past() {
      return this.items.filter(b => {
        return compareAsc(new Date(b.end_datetime * 1000), new Date()) < 0
      })
    },
  },
  methods: {
    handleRememberPosition(elId) {
      this.$emit('element-render', elId)
    },
  },
}
</script>

<style lang="scss" scoped>
.bootcamp-list-results {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  &__list-item {
    min-width: 100%;
    height: 106px;
    padding: 0;
    margin-bottom: 10px;
  }
  &__title {
    color: var(--white);
    font-size: rem(20px);
    font-weight: bold;
    width: 100%;
  }
  &__past {
    width: 100%;
  }
}
</style>
